const RESOURCES_TYPES = [
	{id: 1, label: "Hours", type: "histogram_resource"},
	{id: 2, label: "Cost", type: "histogram_resource"},
	{id: 3, label: "Price", type: "histogram_resource"}
];

export default RESOURCES_TYPES;
